
const m = window.require("ember-cp-validations/validators/base");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
